import { councilReportApi } from "@/lib/api"
import { useQuery, UseQueryOptions } from "@tanstack/react-query"
import type {
  DailyNotificationSendActivityDTO,
  ApiResponseListDailyNotificationSendActivityDTO,
} from "@/gen/api"

interface DailyNotificationSendActivityReportParams {
  councilId: string
  startDate?: string
  endDate?: string
}

const useDailyNotificationSendActivityReport = (
  params: DailyNotificationSendActivityReportParams,
  options?: Omit<UseQueryOptions<DailyNotificationSendActivityDTO[]>, "queryKey">,
) => {
  return useQuery<DailyNotificationSendActivityDTO[]>({
    queryKey: [useDailyNotificationSendActivityReport.QUERY_KEY, params],
    queryFn: async () => {
      const response = await councilReportApi.getDailyNotificationSendActivityReport(
        params.councilId,
        params.startDate,
        params.endDate,
      )
      return (response.data as ApiResponseListDailyNotificationSendActivityDTO).data ?? []
    },
    enabled: !!params.councilId,
    ...options,
  })
}

useDailyNotificationSendActivityReport.QUERY_KEY = "daily-notification-send-activity-report"

export default useDailyNotificationSendActivityReport
